import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import { CheckCircle } from 'lucide-react';

const SelectionGuidePage = () => {
  const guides = [
    {
      title: 'Timing Belts',
      applications: ['Precision machinery', 'Robotics', 'Automotive engines', 'CNC machines'],
      features: ['Synchronous transmission', 'No slip operation', 'High efficiency', 'Low maintenance'],
      specs: 'Ideal for applications requiring precise speed ratios'
    },
    {
      title: 'V-Belts',
      applications: ['HVAC systems', 'Agricultural equipment', 'Industrial fans', 'Compressors'],
      features: ['Wedge design', 'High friction grip', 'Cost-effective', 'Easy installation'],
      specs: 'Best for general purpose power transmission'
    },
    {
      title: 'Flat Belts',
      applications: ['High-speed drives', 'Textile machinery', 'Paper mills', 'Printing presses'],
      features: ['Smooth operation', 'High speed capability', 'Flexibility', 'Low noise'],
      specs: 'Suitable for speeds up to 100 m/s'
    },
    {
      title: 'Conveyor Belts',
      applications: ['Mining operations', 'Food processing', 'Packaging lines', 'Logistics'],
      features: ['Heavy load capacity', 'Abrasion resistant', 'Temperature resistant', 'Customizable'],
      specs: 'Available in various materials and surface types'
    },
    {
      title: 'Poly-V Belts',
      applications: ['Automotive serpentine drives', 'Machine tools', 'Exercise equipment'],
      features: ['Multi-rib design', 'Compact drives', 'High power density', 'Flexible routing'],
      specs: 'Combines benefits of flat and V-belts'
    }
  ];

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <div className="pt-32 pb-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 text-center">
            <h1 className="heading-font text-4xl text-[#1E293B] mb-4" data-testid="selection-guide-title">
              BELT SELECTION GUIDE
            </h1>
            <p className="text-[#64748B] text-base max-w-2xl mx-auto">
              Choose the right belt for your application with our comprehensive selection guide
            </p>
          </div>

          <div className="space-y-8">
            {guides.map((guide, index) => (
              <div key={index} className="glass-card p-8" data-testid={`guide-${index}`}>
                <h2 className="heading-font text-2xl text-[#1E293B] mb-6">{guide.title}</h2>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <h3 className="text-[#3B82F6] font-semibold mb-3 text-sm">TYPICAL APPLICATIONS</h3>
                    <ul className="space-y-2">
                      {guide.applications.map((app, i) => (
                        <li key={i} className="flex items-start space-x-2 text-[#64748B] text-sm">
                          <CheckCircle size={16} className="text-[#3B82F6] mt-0.5 flex-shrink-0" />
                          <span>{app}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-[#3B82F6] font-semibold mb-3 text-sm">KEY FEATURES</h3>
                    <ul className="space-y-2">
                      {guide.features.map((feature, i) => (
                        <li key={i} className="flex items-start space-x-2 text-[#64748B] text-sm">
                          <CheckCircle size={16} className="text-[#3B82F6] mt-0.5 flex-shrink-0" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-[#3B82F6] font-semibold mb-3 text-sm">SPECIFICATIONS</h3>
                    <p className="text-[#64748B] text-sm">{guide.specs}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 glass-card p-8 text-center">
            <h2 className="heading-font text-2xl text-[#1E293B] mb-4">NEED HELP SELECTING?</h2>
            <p className="text-[#64748B] mb-6">
              Our technical team can help you choose the right belt for your specific application
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="mailto:sales@simpsonmunro.in" className="btn-accent inline-flex items-center justify-center px-8 py-3 text-[#1E293B] font-bold uppercase tracking-wider">
                Contact Technical Team
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SelectionGuidePage;